import chartService from '@/shared/services/chart.service'
const ChartsStore = {
    namespaced: true,
  
    state: {
      chartCollections: {
        JLL: [],
        Tetris: [],
        Overview: []
      },
      filters: {
        Year: {
          key:"Total",
          value:undefined
        }
      }
    },
  
    mutations: {
      SET_CHART_COLLECTION(state, { chartCollectionKey, chartCollection }) {
        state.chartCollections[chartCollectionKey] = chartCollection;
      },
      SET_FILTERS(state, filters){
        state.filters = {...filters}
      }
    },
  
    actions: {
      async SetChartCollectionInitial({ commit }, { model, chartCollectionKey }) {
        const chartsMapped = await chartService.mapChart(model);
        commit("SET_CHART_COLLECTION", { chartCollectionKey, chartCollection: chartsMapped });
      },

      SetFilters({commit}, filters) {
        commit("SET_FILTERS", filters);
      }
    },
  
    getters: {
      GetChartCollections: (state) => (key) => state.chartCollections[key] ?? [],
      GetFilters: (state) => state.filters,
    }
  };
  
  export default ChartsStore;